export enum AppButtonType {
  Basic = 'basic',
  Basic_Red = 'basicRed',
  Raised = 'raised',
  Stroked = 'stroked',
  Flat = 'flat',
  Icon = 'icon',
  Fab = 'fab',
  Link = 'link',
  Icon_Stroked = 'iconStroked',
  Icon_Stroked_Red = 'iconStrokedRed',
}

export enum AppButtonSize {
  Basic = 'basic',
  InFilterRow = 'inFilterRow',
  InOperationRow = 'inOperationRow',
  FullWidth = 'fullWidth',
  Width60prc = 'width60prc',
  Small = 'small',
  ExtraSmall = 'extraSmall',
  FullHeight = 'fullHeight',
}

export enum AppLabelColors {
  ORANGE = 'orange',
  RED = 'red',
  BLUE = 'blue',
  GREY = 'grey',
}
